export default __webpack_public_path__ + "alberta-support.8fe85dbd588203e8a293.svg";